<app-loading
  [loading] = loading
></app-loading>

<div class="modal-overlay" *ngIf="modalDetalhes" (click)="!loading && fecharModal()">
  <div class="box-detalhe-tarefa" (click)="$event.stopPropagation()">
    <div class="row">
      <div class="col-md-10">
        <h5 class="fw-bold">
          <i class="fa fa-check-square"></i> {{tarefa.descricao}}
        </h5>
      </div>
      <div class="col-md-2 text-end">
        <button type="button" class="btn-close" (click)="fecharModal()" aria-label="Close" [disabled]="loading"></button>
      </div>
    </div>
    <hr>

    <div class="row g-3">
      <!-- Informações Básicas -->
      <div class="col-md-12">
        <div class="row g-2">
          <div class="col-md-4">
            <i class="fa fa-user me-1"></i> <b>Responsável: </b><br> {{tarefa.responsavel}}
          </div>
          <div class="col-md-8" *ngIf="tarefa.processoId && tarefa.processoId > 0">
            <i class="fa fa-telegram me-1"></i> <b>Processo: </b><br> {{tarefa.numeroProcesso}} - {{tarefa.processo}}
          </div>
          <div class="col-md-8" *ngIf="tarefa.atendimentoId && tarefa.atendimentoId > 0">
            <i class="fa fa-headphones me-1"></i> <b>Atendimento: </b><br> {{tarefa.atendimento}}
          </div>
          <div class="col-md-4">
            <i class="fa fa-calendar me-1"></i> <b>Cadastro: </b><br> {{tarefa.dataCadastro | date: "dd/MM/yyyy"}}
          </div>
          <div class="col-md-4">
            <i class="fa fa-calendar me-1"></i> <b>Início: </b><br> {{tarefa.dataInicial | date: "dd/MM/yyyy"}}
          </div>
          <div class="col-md-4">
            <i class="fa fa-calendar-check-o me-1"></i> <b>Previsão: </b><br> {{tarefa.dataPrevisaoFinalizacao | date: "dd/MM/yyyy"}}
          </div>
          <div class="col-md-4">
            <i class="fa fa-check-circle-o me-1"></i> <b>Tipo: </b><br> {{tarefa.tipoTarefa}}
          </div>
          <div class="col-md-4">
            <i class="fa fa-money me-1"></i> <b>Valor: </b><br> R$ {{tarefa.valor}}
          </div>
        </div>
      </div>

      <hr>

      <div class="col-md-8">
        <!-- Descrição Detalhada -->
        <div class="mb-4">
          <label class="form-label fw-bold"><i class="fa fa-align-justify me-1"></i> Descrição detalhada</label>
          <textarea (focus)="botaoSalvarDescricao = true; botaoSalvarAtivadade = false"
                    [(ngModel)]="tarefa.descricaoDetalhada"
                    class="form-control"
                    style="height: 150px;"></textarea>
          <div *ngIf="botaoSalvarDescricao" class="mt-2 d-flex gap-2">
            <button (click)="salvar()" class="btn btn-primary btn-sm">Salvar</button>
            <button (click)="cancelar()" class="btn btn-light btn-sm">Cancelar</button>
          </div>
        </div>

        <!-- Atividades/Comentários -->
        <div class="mb-4">
          <label class="form-label fw-bold"><i class="fa fa-adjust me-1"></i> Atividades</label>
          <div class="input-group mb-2">
            <input (focus)="botaoSalvarAtivadade = true; botaoSalvarDescricao = false"
                   [(ngModel)]="tarefa.comentario" type="text"
                   class="form-control"
                   placeholder="Escrever um comentário....">
            <button *ngIf="botaoSalvarAtivadade" (click)="salvar()" class="btn btn-primary">Salvar</button>
            <button *ngIf="botaoSalvarAtivadade" (click)="cancelar()" class="btn btn-light">Cancelar</button>
          </div>

          <div class="mt-3">
            <div *ngFor="let item of tarefa.comentariosDetalhes" class="comentario-item">
              <div class="mb-1">{{item.texto}}</div>
              <div class="textoinformacao">
                <i class="fa fa-calendar-times-o"></i> {{item.dataRealizado | date: "dd/MM/yyyy HH:mm" }} -
                <i class="fa fa-user"></i> {{item.usuario}}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Ações e Histórico -->
      <div class="col-md-4">
        <div class="card bg-light border-0">
          <div class="card-body">
            <h6 class="fw-bold mb-3">Ações</h6>
            <div *ngIf="tarefa.status != StatusTarefa.Fechada" class="d-grid gap-2">
              <button (click)="showModalAtribuir = !showModalAtribuir" class="btn btn-outline-primary btn-sm">
                <i class="fa fa-user-plus"></i> Atribuir
              </button>

              <div *ngIf="showModalAtribuir" class="p-2 border rounded bg-white mb-2">
                <ng-select [items]="usuarios.itens"
                           bindLabel="nome"
                           bindValue="id"
                           [(ngModel)]="tarefa.responsavelId"
                           [clearable]="false"
                           class="mb-2">
                </ng-select>
                <button (click)="atribuir()" class="btn btn-primary btn-sm w-100"><i class="fa fa-save"></i> Salvar Atribuição</button>
              </div>

              <button (click)="showModalModificarStatus = !showModalModificarStatus" class="btn btn-outline-primary btn-sm">
                <i class="fa fa-exchange"></i> Modificar status
              </button>

              <div *ngIf="showModalModificarStatus" class="p-2 border rounded bg-white mb-2">
                <ng-select [items]="statusLista"
                           bindLabel="descricao"
                           bindValue="id"
                           [(ngModel)]="statusAtualizar"
                           [clearable]="false"
                           class="mb-2">
                </ng-select>
                <button (click)="modificarStatus()" class="btn btn-primary btn-sm w-100"><i class="fa fa-save"></i> Atualizar Status</button>
              </div>

              <button *ngIf="tarefa.status == StatusTarefa.Afazer || tarefa.status == StatusTarefa.Planejamento" (click)="iniciar()" class="btn btn-success btn-sm">
                <i class="fa fa-play"></i> Iniciar
              </button>

              <button (click)="finalizar()" class="btn btn-info btn-sm text-white">
                <i class="fa fa-check"></i> Finalizar
              </button>

              <button (click)="desativar()" class="btn btn-danger btn-sm">
                <i class="fa fa-archive"></i> Arquivar
              </button>
            </div>
            <div *ngIf="tarefa.status == StatusTarefa.Fechada" class="alert alert-info py-2">
              Tarefa finalizada.
            </div>

            <hr>

            <h6 class="fw-bold mb-3">Histórico</h6>
            <div class="historico-container" style="max-height: 200px; overflow-y: auto;">
              <div *ngFor="let item of tarefa.movimentacoesDetalhes" class="historico-item">
                <div class="small fw-bold text-primary">Foi realizado o processo de {{item.descricao}}</div>
                <div class="textoinformacao">
                  <i class="fa fa-user"></i> por {{item.usuario}} -
                  <i class="fa fa-calendar-times-o"></i> {{item.dataRealizado | date: "dd/MM/yyyy HH:mm" }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
